export default __webpack_public_path__ + "static/media/Insight_data_tableau_récap_16.91b2ff71.svg";